/**
 * Reveals text/image blocks with a fade-in + slide-up once they enter the viewport.
 * Scoped to the home page and product pages (see scroll-reveal.css for the matching selectors).
 * Each element reveals once; the marquee is excluded since it has its own continuous animation.
 */
function initScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const candidates = document.querySelectorAll(
    "[data-template^='index'] .text-block, [data-template^='index'] .image-block, " +
      "[data-template^='product'] .text-block, [data-template^='product'] .image-block, " +
      '.stikk-reveal'
  );

  const targets = Array.from(candidates).filter((el) => !el.closest('marquee-component'));
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  for (const target of targets) observer.observe(target);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveal);
} else {
  initScrollReveal();
}
